import React, { useEffect, useState } from 'react';
import { useLoading } from '../../commons/Loading';
import { useAuth } from '../../commons/Auth';
import { useTranslation } from 'react-i18next';
import { useAlert } from 'react-alert';
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from 'use-query-params';
import ExtraInvoiceByMonthPresentational from './ExtraInvoiceByMonthPresentational';
import axios from 'axios';
import './IafsByMonth.scss';

const { REACT_APP_DEFAULT_PAGINATION_LIMIT = 50 } = process.env;

function IafsByMonth(props) {
  const { showLoading, hideLoading } = useLoading();
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [{ newToken } = {}] = useAuth();
  const { t } = useTranslation('DASHBOARD');
  const alert = useAlert();

  const [query, setQuery] = useQueryParams({
    offset: withDefault(NumberParam, 0),
    limit: withDefault(NumberParam, +REACT_APP_DEFAULT_PAGINATION_LIMIT),
    year: withDefault(NumberParam, new Date().getFullYear()),
    profileStatus: withDefault(StringParam),
  });
  const { offset, limit, year, profileStatus } = query;

  const fetchExtraInvoicesByMonth = async (upsert = false) => {
    showLoading();
    setData([]);
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/extra-invoices-by-month`,
      {
        headers: { Authorization: newToken },
        params: { offset, limit, year, profileStatus, upsert },
      }
    );
    hideLoading();
    if (response instanceof Error) {
      return alert.error(t('COMMON:GENERIC_ERROR'));
    }
    setData(response.data || []);
    setTotal(Number(response.headers['x-total-count']));
  };

  function onFilter(queryDiff) {
    if (queryDiff.limit && queryDiff.limit !== limit) {
      queryDiff.offset = 0; // return to first page
    }
    setQuery(queryDiff);
  }

  const onQueueJobRequestConfirm = async () => {
    showLoading();

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/queueJobRequests`,
      {
        year,
        type: 'EXTRA_IAFS',
        business: 'EXTRA',
        service_type: 'iafs_extra',
      },
      {
        headers: { Authorization: newToken },
      }
    );
    if (response instanceof Error) {
      hideLoading();
      return alert.error(t('COMMON:GENERIC_ERROR'));
    }

    const notCreatedNew = response.data?.notCreatedNew;

    if (notCreatedNew === false) {
      alert.success('Richiesta emissione IAF creata correttamente');
    } else if (notCreatedNew === true) {
      alert.error(
        'Richiesta emissione IAF in stato "Non gestita" giá presente. Richiesta non creata.'
      );
    }
    hideLoading();
  };

  useEffect(() => {
    fetchExtraInvoicesByMonth();
  }, [offset, limit, year, profileStatus]);

  return (
    <ExtraInvoiceByMonthPresentational
      data={data}
      total={total}
      query={query}
      onFilter={onFilter}
      fetchExtraInvoicesByMonth={fetchExtraInvoicesByMonth}
      onQueueJobRequestConfirm={onQueueJobRequestConfirm}
      {...props}
    />
  );
}

export default IafsByMonth;
